import { usePublicIpQuota } from '@/hooks/usePublicIpQuota'
import { PUBLIC_IP_QUOTA_CHECKING } from '@/data/publicIp'
import { useInfrastructureWizard } from '@/stores/infrastructureWizard'
import { Button } from '@/components/common/Button'
import styles from './Infrastructure.module.css'

/**
 * What the user is told, next to a public IP question answered Yes, when the subscription cannot give the public IPs the servers want: the
 * backend's message as it is given (the quota is not there, or Azure could not be read), or, when the request itself failed, the portal's
 * own "Couldn't verify public IP quota." Both offer the same two ways on: "Check again" (the quota may have been raised, or the lookup failed
 * for a moment) and "Continue without public IP", which answers No for every server that was Yes, so the problem goes and Next unblocks.
 * Nothing is shown when no public IP is wanted or the quota is there; while the answer is on its way it says so, and Next waits (the same
 * answer is in "To continue"). The answer is shared by every place that asks: see `usePublicIpQuota`.
 */
export function PublicIpQuotaNotice() {
  const { state, message, recheck, isChecking } = usePublicIpQuota()
  const continueWithoutPublicIp = useInfrastructureWizard((s) => s.continueWithoutPublicIp)
  if (state.kind === 'none' || state.kind === 'sufficient') return null
  if (state.kind === 'checking') {
    return (
      <p className={styles.note} role="status" data-testid="public-ip-quota-checking">
        {PUBLIC_IP_QUOTA_CHECKING}
      </p>
    )
  }
  return (
    <div className={styles.alert} role="alert" data-testid="public-ip-quota-notice" data-state={state.kind === 'unreachable' ? 'unreachable' : state.failed ? 'failed' : 'short'}>
      <div>
        <div>{message}</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8 }}>
          <Button type="button" variant="secondary" size="sm" disabled={isChecking} onClick={recheck}>
            {isChecking ? 'Checking…' : 'Check again'}
          </Button>
          <Button type="button" variant="secondary" size="sm" onClick={continueWithoutPublicIp}>
            Continue without public IP
          </Button>
        </div>
      </div>
    </div>
  )
}
